var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a, _b, _c;
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import DataTable from '@/components/data-table/DataTable';
import { SubjectLabel } from '@/models/SubjectLabel';
import { SubjectLabelCategory } from '@/models/SubjectLabelCategory';
import LabelValue from '@/components/LabelValue.vue';
import SubjectLabelCategorySelect from '@/components/SubjectLabelCategorySelect/SubjectLabelCategorySelect.vue';
import ErrorHandler from '@/support/ErrorHandler';
let AddSubjectLabelDialog = class AddSubjectLabelDialog extends Vue {
    constructor() {
        // #region @VModel
        // #endregion
        super(...arguments);
        // #endregion
        // #region @Refs
        // #endregion
        // #region Class properties
        this.subjectLabel = null;
        this.currentStep = 1;
        this.isLoading = true;
        // #endregion
    }
    // #endregion
    // #region Lifecycle Hooks
    mounted() {
        this.initialize();
    }
    async initialize() {
        this.isLoading = true;
        await this.initializeSubjectLabel();
        this.isLoading = false;
    }
    // #endregion
    // #region Event handlers
    // #endregion
    // #region Class methods
    close() {
        this.$emit('input', false);
        this.clear();
    }
    clear() {
        this.subjectLabel = new SubjectLabel();
        this.currentStep = 1;
    }
    onSubmit() {
        if (!this.subjectLabel) {
            return;
        }
        const payload = {
            name: this.subjectLabel.name,
            tag_category_id: this.subjectLabelCategory.id,
        };
        if (this.isEditing) {
            this.onUpdateSubjectLabel(payload);
        }
        else {
            this.onCreateSubjectLabel(payload);
        }
    }
    // #endregion
    // #region Async methods (api calls only)
    async onUpdateSubjectLabel(payload) {
        try {
            await this.existingSubjectLabel.update(payload);
            this.$emit('subjectLabelUpdated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async onCreateSubjectLabel(payload) {
        try {
            await new SubjectLabel().create(payload);
            this.$emit('subjectLabelCreated');
            this.clear();
        }
        catch (error) {
            ErrorHandler.network(error);
        }
    }
    async initializeSubjectLabel() {
        if (this.existingSubjectLabel) {
            this.subjectLabel = this.existingSubjectLabel;
        }
        else {
            this.subjectLabel = new SubjectLabel();
        }
    }
    // #endregion
    // #region Getters & Setters
    get selectedCategoryLabel() {
        return this.subjectLabelCategory && this.subjectLabelCategory.label ? this.subjectLabelCategory.label : '-';
    }
    get disabled() {
        switch (this.currentStep) {
            case 1:
                return !this.subjectLabel || !this.subjectLabel.name;
            case 2:
                return false;
            default:
                return true;
        }
    }
    get submitButtonText() {
        return this.$tc('Save');
    }
    get isEditing() {
        return !!this.existingSubjectLabel;
    }
    get title() {
        return this.isEditing ? this.$tc('Edit tag') : this.$tc('Add tag');
    }
    // #endregion
    // #region @Watchers
    async onExistingSubjectLabelChange() {
        this.isLoading = true;
        await this.initializeSubjectLabel();
        this.isLoading = false;
    }
};
__decorate([
    Prop({ required: true }),
    __metadata("design:type", typeof (_a = typeof SubjectLabelCategory !== "undefined" && SubjectLabelCategory) === "function" ? _a : Object)
], AddSubjectLabelDialog.prototype, "subjectLabelCategory", void 0);
__decorate([
    Prop({ required: false }),
    __metadata("design:type", typeof (_b = typeof SubjectLabel !== "undefined" && SubjectLabel) === "function" ? _b : Object)
], AddSubjectLabelDialog.prototype, "existingSubjectLabel", void 0);
__decorate([
    Watch('existingSubjectLabel'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", typeof (_c = typeof Promise !== "undefined" && Promise) === "function" ? _c : Object)
], AddSubjectLabelDialog.prototype, "onExistingSubjectLabelChange", null);
AddSubjectLabelDialog = __decorate([
    Component({
        components: {
            DataTable,
            LabelValue,
            SubjectLabelCategorySelect,
        },
    })
], AddSubjectLabelDialog);
export default AddSubjectLabelDialog;
// #region Enums
// #endregion
// #region Interfaces
// #endregion
// #region Constants
// #endregion
